import React from "react";
import { IconProps } from "../icon";

export const Sliders_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 21v-6m0 0a2 2 0 100-4 2 2 0 000 4zm0-8V3m7 18v-6m0-8V3m0 4a2 2 0 100 4 2 2 0 000-4zm7 14v-4m0 0a2 2 0 100-4 2 2 0 000 4zm0-8V3"
    />
  </svg>
);
